module.exports = __webpack_public_path__ + "img/Flag_of_Maldives.5027047f.svg";